import { GET_PROFILE, PROFILE_LOADING, UPDATE_PROFILE, UPDATE_PROFILE_SUCCESS, UPDATE_PROFILE_FAIL } from '../actions/types';

const initialState = {
  profile: null,
  loading: false,
  updateSuccess: false,
  updateError: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_PROFILE:
      return {
        ...state,
        profile: action.payload,
        loading: false,
        updateSuccess: false,
        updateError: null
      };
    case PROFILE_LOADING:
      return {
        ...state,
        loading: true
      };
    case UPDATE_PROFILE:
      return {
        ...state,
        loading: true,
        updateSuccess: false,
        updateError: null
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.payload,
        loading: false,
        updateSuccess: true,
        updateError: null
      };
    case UPDATE_PROFILE_FAIL:
      return {
        ...state,
        loading: false,
        updateSuccess: false,
        updateError: action.payload
      };
    default:
      return state;
  }
} 
